import { useSelector } from "store";

import type { Store } from "store";

/**
 * ライブコマースで購入が完了したか。
 * 親コンポーネントが完了を検知して閉じる・トーストを出すためだけに読む。
 */
export const useLiveCommercePurchased = (): boolean =>
  useSelector((state: Store) => state.streaming.liveCommerce.isPurchased);
